import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { VariationsOfRightRibbons } from "../../../../Constant";
import { RIGHT_RIBBONS_DATA } from "../../../../Data/Bonus Ui/Ribbons";
import { StaticRightRibbons } from "./StaticRightRibbons";
import { DynamicRightRibbons } from "./DynamicLeftRibbons";

const  RightRibbons = () => {
  return (
    <Row>
      <Col sm="12" xl="12">
        <Card>
          <CommonCardHeader title={VariationsOfRightRibbons} span={RIGHT_RIBBONS_DATA} />
          <CardBody>
            <Row className="g-3">
              <StaticRightRibbons />
              <DynamicRightRibbons />
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default RightRibbons;
